import React, { useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "./EnquiryModal.css";

export default function EnquiryModal({ open, onClose, onSuccess, project }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     // 🔥 API CALL
  //     await axios.post("http://localhost:5000/api/contact", formData);

  //     // ✅ optional success callback
  //     if (onSuccess) onSuccess();                                       

  //     // 🔥 DOWNLOAD BROCHURE AFTER SUCCESS
  //     const link = document.createElement("a");
  //     link.href = project;   // brochure file path
  //     link.download = "Jayaram-Infracon-Brochure.pdf";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     alert("Brochure Download");

  //     // reset form
  //     setFormData({
  //       name: "",
  //       phone: "",
  //       email: "",
  //       message: "",
  //     });

  //     onClose();

  //   } catch (error) {
  //     console.error(error);
  //     alert("Something went wrong ❌");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {

    await axios.post(
      "https://knsonline.in/uat/RestAPI_V1/cp/v1/sendEmailToCustomer",
      JSON.stringify(formData),
      {
        headers: {
         Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
        }
      } 
    );

    // ✅ optional success callback
    if (onSuccess) onSuccess();

    // 🔥 DOWNLOAD BROCHURE AFTER SUCCESS
    const link = document.createElement("a");
    link.href = project;
    link.download = "Jayaram-Infracon-Brochure.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    alert("Brochure Download Started ✅");

    // reset form
    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
    });

    onClose();

  } catch (error) {
    console.error(error.response || error);
    alert("Something went wrong ❌");
  } finally {
    setLoading(false);
  }
};

  return ReactDOM.createPortal(
    <div className="modal-overlay" onMouseDown={onClose}>
      <div
        className="modal-container"
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="modal-header">
          <h3>Download the Full Brochure</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <p className="modal-subtext">
          Please share your contact details to receive the brochure.
        </p>

        {/* FORM */}
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="grid">
            <input
              type="text"
              name="name"
              placeholder="Full Name *"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Mobile Number *"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <input
            type="email"
            name="email"
            placeholder="Email Address *"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            rows="3"
            name="message"
            placeholder="Your Requirement"
            value={formData.message}
            onChange={handleChange}
          />

          <label className="checkbox">
            <input type="checkbox" required />
            I agree to the Terms of Use and Privacy Policy
          </label>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Processing..." : "Download Now"}
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
}
